import React, { useEffect, useRef } from 'react';
import styles from './ParticleCanvas.module.css';

export default function ParticleCanvas() {
  const canvasRef = useRef(null);

  useEffect(() => {
    const canvas = canvasRef.current;
    if (!canvas) return;
    const ctx = canvas.getContext('2d');
    let animId;
    let particles = [];

    const resize = () => {
      canvas.width = canvas.offsetWidth;
      canvas.height = canvas.offsetHeight;
    };

    const rand = (min, max) => Math.random() * (max - min) + min;

    const createParticle = (overrideY) => ({
      x: rand(0, canvas.width),
      y: overrideY !== undefined ? overrideY : rand(0, canvas.height),
      r: rand(1, 2.8),
      vx: rand(-0.18, 0.18),
      vy: rand(-0.55, -0.25),
      alpha: rand(0.08, 0.45),
      alphaDir: rand(-0.001, 0.001),
    });

    const init = () => {
      resize();
      particles = Array.from({ length: 70 }, () => createParticle());
    };

    const draw = () => {
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      particles.forEach(p => {
        p.x += p.vx;
        p.y += p.vy;
        p.alpha += p.alphaDir;
        if (p.alpha <= 0.05) p.alphaDir = Math.abs(p.alphaDir);
        if (p.alpha >= 0.45) p.alphaDir = -Math.abs(p.alphaDir);
        if (p.y < -10) { Object.assign(p, createParticle(canvas.height + 5)); }
        if (p.x < -10) p.x = canvas.width + 5;
        if (p.x > canvas.width + 10) p.x = -5;

        ctx.beginPath();
        ctx.arc(p.x, p.y, p.r, 0, Math.PI * 2);
        ctx.fillStyle = `rgba(200, 167, 91, ${p.alpha})`;
        ctx.fill();
      });
      animId = requestAnimationFrame(draw);
    };

    init();
    draw();

    const handleResize = () => {
      resize();
      particles.forEach(p => {
        if (p.x > canvas.width) p.x = rand(0, canvas.width);
        if (p.y > canvas.height) p.y = rand(0, canvas.height);
      });
    };
    window.addEventListener('resize', handleResize);

    return () => {
      cancelAnimationFrame(animId);
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  return <canvas ref={canvasRef} className={styles.canvas} aria-hidden="true" />;
}
